export class PricingSpecSearchEnabledException extends Error {
  constructor() {
    super('Pricing spec search is enabled');
  }
}
